import { useRef, useState } from 'react'
import styles from './styles/CopyButton.css'
import Tooltip from './Tooltip'

const CopyButton = ({ onClick, tooltipContent = 'Click to copy', clickedState = false }) => {
  const interval = useRef()
  const [clicked, setClicked] = useState(clickedState)

  return (
    <Tooltip content={tooltipContent}>
      <i
        className={(clicked || clickedState) ? styles.copySuccess : styles.copyButton}
        role='button'
        tabIndex='0'
        onClick={e => {
          if (interval.current) {
            clearTimeout(interval.current)
          }

          onClick(e)
          setClicked(true)
          interval.current = setTimeout(() => setClicked(false), 1000)
        }}
      />
    </Tooltip>
  )
}

export default CopyButton
